const ServicesApi=[
    {
        id:1,
        logo:"fas fa-download",
        title:"Instant activation",
        info: "Paytm offers 100% online onboarding with minimum documentation to help your business go online with ease."
    },
    {
        id:2,
        logo:"fas fa-user-check",
        title:"Easy integration",
        info: "Use OnlinePay's robust APIs and custom SDKs to start accepting digital payments in less than 30 minutes using just a few lines of code"
    },
    {
        id:3,
        logo:"fas fa-money-check-alt",
        title:"India's most widely-used checkout",
        info: "Over 450 million Indians prefer the Paytm Checkout & you can now give your customers the checkout experience they love."
    },
    {
        id:4,
        logo:"fab fa-amazon-pay",
        title:"100+ payment sources",
        info: "Allow your customers to pay way they want with support for debit and credit cards, Netbanking, UPI, Paytm Wallet & more"
    },
    {
        id:5,
        logo:"fas fa-hand-holding-usd",
        title:"Industry-best success rates",
        info: "With Paytm’s intelligent routing & direct bank integrations, we ensure that your customers’ payments go through every time"
    },
    {
        id:6,
        logo:"fas fa-globe",
        title:"Dedicated support",
        info: "All online merchants and payment gateway users on Paytm get dedicated support via a toll-free number and email"
    }

]

export default ServicesApi